import type {UserEvent, UserEventDetailComponentProps} from '@cohort/merchants/apps';
import {formatDetailComponentBoldText} from '@cohort/merchants/apps/cohort/utils/format';
import {getPerkRoute} from '@cohort/merchants/lib/Pages';
import type {CohortPerkReceivedEventStruct} from '@cohort/shared/apps/cohort/userEvents/perk/perkReceived';
import {CohortPerkReceivedEventSpec} from '@cohort/shared/apps/cohort/userEvents/perk/perkReceived';
import {Trans} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

const DetailComponent: React.FC<UserEventDetailComponentProps> = ({userEvent}) => {
  const perkId = (userEvent.properties as CohortPerkReceivedEventStruct['Properties']).perkId;
  const perkInternalName = userEvent.perkInternalName;
  const navigate = useNavigate();
  return (
    <Trans
      i18nKey="userEvents.perk.received.detail"
      ns="app-cohort"
      values={{
        perkInternalName,
      }}
      components={{
        bold: formatDetailComponentBoldText(userEvent, () => navigate(getPerkRoute(perkId).path)),
      }}
    />
  );
};

export const CohortPerkReceivedUserEvent: UserEvent<CohortPerkReceivedEventStruct> = {
  spec: CohortPerkReceivedEventSpec,
  detailComponent: DetailComponent,
};
